41
.addEventListener('DOMContentLoaded', function () {
  var game = document.getElementById('jxk-gacha');
  if (!game) return;

  var prizeNode = game.querySelector('[data-gacha-result]');
  var codeNode = game.querySelector('[data-gacha-code]');
  if (!prizeNode || !codeNode) return;

  var prizes = [
    { name: '50% OFF クーポン', limit: 2 },
    { name: '40% OFF クーポン', limit: 6 },
    { name: '30% OFF クーポン', limit: 12 },
    { name: '20% OFF クーポン', limit: 25 },
    { name: '10% OFF クーポン', limit: 55 }
  ];

  function pickPrize() {
    var roll = Math.random() * 100;
    var total = 0;
    for (var i = 0; i < prizes.length; i += 1) {
      total += prizes[i].limit;
      if (roll < total) return prizes[i].name;
    }
    return '10% OFF クーポン';
  }

  function newNumber() {
    var date = new Date();
    var stamp = String(date.getFullYear()) +
      String(date.getMonth() + 1).padStart(2, '0') +
      String(date.getDate()).padStart(2, '0');
    var value = new Uint32Array(1);
    if (window.crypto && window.crypto.getRandomValues) {
      window.crypto.getRandomValues(value);
    } else {
      value[0] = Math.floor(Math.random() * 1000000);
    }
    return stamp + String(value[0] % 1000000).padStart(6, '0');
  }

  function getTicket() {
    var key = 'jxk_gacha_coupon_v1';
    try {
      var saved = window.localStorage.getItem(key);
      if (saved) return JSON.parse(saved);
      var ticket = { prize: pickPrize(), code: newNumber() };
      window.localStorage.setItem(key, JSON.stringify(ticket));
      return ticket;
    } catch (error) {
      return { prize: pickPrize(), code: newNumber() };
    }
  }

  function revealTicket() {
    var ticket = getTicket();
    prizeNode.textContent = ticket.prize;
    codeNode.textContent = ticket.code;
  }

  game.addEventListener('toggle', function () {
    if (game.open) revealTicket();
  });
});